import * as angular from "angular";
import viewExportInformationTab from "./view-export-information-tab";
import viewExportMetadataTab from "./view-export-metadata-tab";
import viewExportReportsTab from "./view-export-reports-tab";

export default angular
	.module("vesl.components.exports.view-export.tabs", [
		viewExportInformationTab,
		viewExportMetadataTab,
		viewExportReportsTab
	])
	.name;
